module.exports = __webpack_public_path__ + "img/sport4.1f700e16.png";